export type FusionBotTypeOption = { label: string, value: string, icon: string };

// systemConf-Parameter bleibt für Abwärtskompatibilität mit bestehenden Aufrufstellen erhalten, wird aber nicht mehr ausgewertet.
export const getFusionBotTypeOptions = (_systemConf: string): FusionBotTypeOption[] => {
  return [
    { label: $localize`:@@chat-bot:Chat-Bot`, value: '', icon: 'ri-chat-3-line' },
    { label: $localize`:@@voice-bot:Audio-Bot`, value: 'audio', icon: 'ri-volume-up-line' },
    { label: $localize`:@@avatar-bot:Avatar-Bot`, value: 'avatar', icon: 'ri-user-voice-line' },
    { label: $localize`:@@did-avatar-bot:D-ID Avatar-Bot`, value: 'did-avatar', icon: 'ri-video-ai-fill' }
  ];
};

export const capitalizeOrParse = (str: string) => {
  str = str.replace("iframely_", "");
  if (str == "youtube") {
    return "YouTube";
  }
  if (str == "htmlpage") {
    return $localize`:@@fusion-htmlpage-full:HTML: Freie Gestaltung`;
  }
  if (str == "html-as-media") {
    return $localize`:@@fusion-html-as-media:HTML: Medieninhalt`;
  }
  if (str == "miro-by-template") {
    return $localize`:@@miro-by-template:Miro: Board von Template`;
  }
  if (str == "miro-by-url") {
    return $localize`:@@miro-by-url:Miro: Board von URL`;
  }




  if (str == "none") {
    return $localize`:@@fusion-none:Keiner`;
  }
  return str.substring(0, 1).toUpperCase() + str.substring(1);
};
